import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LoadingIndicator from 'components/LoadingIndicator';
import { getSyncStore } from 'globals/selectors';
import withRouterSpecialisation from 'globals/withRouterSpecialisation';
import {
  createCancellableRequestAPI,
  fetchCustomDataWithRetry,
} from 'utils/request';

const withSyncStoreRouterSpecialisation = (CustomComponent, syncStoreKeys) =>
  withRouterSpecialisation(props => {
    const [
      cancellableGetSyncStoreRequestAPI,
      cancelGetSyncStoreRequestAPI,
    ] = createCancellableRequestAPI();

    const { specialisation } = props;
    const dispatch = useDispatch();
    const syncStore = useSelector(getSyncStore);
    const emptySyncStoreKeys = syncStoreKeys.filter(
      syncStoreKey => syncStore[syncStoreKey] === undefined,
    );

    const [data, setData] = useState({
      isFetching: emptySyncStoreKeys.length > 0,
      error: false,
    });

    useEffect(() => {
      if (specialisation) {
        fetchCustomDataWithRetry(
          cancellableGetSyncStoreRequestAPI,
          `/${specialisation}/syncstore?keys=${emptySyncStoreKeys.join(
            '&keys=',
          )}`,
          { credentials: 'include' },
          data,
          setData,
          dispatch,
        );
      }
      return cancelGetSyncStoreRequestAPI;
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.isFetching, specialisation]);

    return specialisation &&
      (data.isFetching || data.error || emptySyncStoreKeys.length > 0) ? (
      <LoadingIndicator />
    ) : (
      <CustomComponent specialisation={specialisation} {...props} />
    );
  });

export default withSyncStoreRouterSpecialisation;
